export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const MS_PER_MINUTE = SECONDS_PER_MINUTE * MS_PER_SECOND;
export const MS_PER_HOUR = MINUTES_PER_HOUR * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;

/** Parses an ISO date string to milliseconds. Returns null if the string is unparseable. */
export function parseDateMs(dateString: string): number | null {
  const ms = new Date(dateString).getTime();
  return Number.isNaN(ms) ? null : ms;
}
